import React from "react";

const DeleteLeftIcon = ({ className, size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M8.6 5.5H19C20.1 5.5 21 6.4 21 7.5V16.5C21 17.6 20.1 18.5 19 18.5H8.6C8 18.5 7.5 18.2 7.1 17.8L3 12L7.1 6.2C7.5 5.8 8 5.5 8.6 5.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M11.5 9.5L16.5 14.5M16.5 9.5L11.5 14.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default DeleteLeftIcon;
